module.exports = __webpack_public_path__ + "static/media/guapuruvu.51329715.jpeg";